import { Modal } from "@material-ui/core";
import styles from "./ConfirmationModal.module.scss";
import { Spinner } from "reactstrap";

export interface IConfirmationModal {
  open: boolean;
  title?: string;
  message?: string;
  buttons?: IButton[];
  onClose: () => void;
}

export interface IButton {
  label: string;
  style?: "info" | "error" | "success" | "warning";
  loading: boolean;
  onClick: () => void;
}

const ConfirmationModal = ({ open, title, message, buttons = [], onClose }: IConfirmationModal) => {
  return (
    <Modal open={open} onClose={onClose} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className={styles.modalContent}>
        <div className={styles.title}>{title}</div>
        {message && <div className={styles.message}>{message}</div>}
        <div className={styles.buttonContainer}>
          {buttons.map((button, index) => (
            <button key={index} disabled={button?.loading} className={`${styles.button} ${styles[button?.style || "success"]}`} onClick={button.onClick}>
              {button?.loading ? <Spinner size={"sm"} /> : button?.label}
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
